import { Button, Modal } from "react-bootstrap";

import './DeleteImageModal.scss';

const DeleteImageModal = ({
        show,
        deleteSharedImage
    }) => {

    return (
        <>
            <Modal
                show={show}
                size="lg"
                centered
                className="delete-image-tab-modal"
            >   
                <Modal.Body className="delete-image-tab-modal-body">
                    <h2 className="delete-image-tab-header">Delete</h2>
                    <p className="delete-image-tab-content">The image to be deleted might have been used in slides. <span className="delete-image-tab-confirmation-text">Are you sure?</span></p>
                </Modal.Body>
                <Modal.Footer className="delete-image-tab-footer">
                    <Button onClick={() => deleteSharedImage('No', '')} className="delete-image-tab-confirmation-no">
                        NO
                    </Button>
                    <Button onClick={() => deleteSharedImage('Yes', '')} className="delete-image-tab-confirmation-yes">
                        YES, DELETE
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DeleteImageModal;